import { CompleteStep } from './CompleteStep';
import { InitialStep } from './InitialStep';
import { FeedbackStep } from './Steps.types';

export const FeedbackCaptureSteps = {
  [FeedbackStep.INITIAL]: {
    Component: InitialStep,
    next: FeedbackStep.COMPLETE
  },
  [FeedbackStep.COMPLETE]: {
    Component: CompleteStep,
    next: null
  }
};
